import React from 'react';

import { ProductItem, Status } from 'components/Atoms';
import * as Molecules from 'components/Molecules';
import * as Organisms from 'components/Organisms';

import { Container } from './styles';
import { IFilterCardapioItem } from './interfaces';

export const FilterCardapioItem: React.FC<IFilterCardapioItem> = ({
  isSelected,
  children,
  ...rest
}) => {
  return (
    <Container isSelected={isSelected} {...rest}>
      {children}
    </Container>
  );
};
